import { LanguagesEnum } from '@/api/enums';
import { rtlLanguages } from '@/common/constants/languages';

export const determineAttemptLanguage = (
  userLanguage: string | LanguagesEnum,
  supportedLanguages: LanguagesEnum[],
  urlOverride?: string | null,
): LanguagesEnum => {
  if (
    urlOverride &&
    supportedLanguages.includes(urlOverride as LanguagesEnum)
  ) {
    return urlOverride as LanguagesEnum;
  }

  if (
    userLanguage &&
    supportedLanguages.includes(userLanguage as LanguagesEnum)
  ) {
    return userLanguage as LanguagesEnum;
  }

  return LanguagesEnum.EN;
};

export const isRtlLanguage = (language: LanguagesEnum | undefined): boolean => {
  return language ? rtlLanguages.includes(language) : false;
};

export const toBcp47 = (language: LanguagesEnum | string): string => {
  return language.split('_')[0];
};
